import React, { useState, useEffect } from 'react';

const DownloadApp = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [qrHover, setQrHover] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById('download-app');
      if (section) {
        const rect = section.getBoundingClientRect();
        const isInView = rect.top < window.innerHeight - 100;
        setIsVisible(isInView);
      }
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const apps = [
    {
      id: 1,
      name: 'MomoLive',
      description: 'Live streaming dengan berbagai fitur menarik',
      iconImage: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRH2q4Wfytz41NdmgR9MMBjioTuvhUfxxz_2zWGeaZS-A&s=10', // Ganti dengan path gambar PNG Anda
      playStoreUrl: 'https://play.google.com/store/apps/details?id=com.huixin.momo',
      apkUrl: 'https://qnoss.momoindo.com/apk/official/momo_live.apk',
      color: '#F7C948',
      badge: 'Rekomendasi'
    }
  ];

  const handleDownload = (url, appName, type) => {
    // Show notification
    const notification = document.createElement('div');
    notification.className = 'toast-notification show';
    notification.innerHTML = `
      <i class="fas fa-download"></i>
      <span>Mengunduh ${appName} dari ${type === 'playstore' ? 'Google Play Store' : 'APK'}...</span>
    `;
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.classList.remove('show');
      setTimeout(() => notification.remove(), 500);
    }, 3000);

    // Open download link
    if (url && url !== '#') {
      window.open(url, '_blank');
    } else {
      // Simulate download for demo
      alert(`Link download ${appName} akan tersedia segera.\nSilakan hubungi admin untuk informasi lebih lanjut.`);
    }
  };

  const copyReferralCode = () => {
    const referralCode = 'WANMGMT2024';
    navigator.clipboard.writeText(referralCode);
    
    const notification = document.createElement('div');
    notification.className = 'toast-notification show';
    notification.innerHTML = `
      <i class="fas fa-check-circle"></i>
      <span>Kode referral ${referralCode} telah disalin!</span>
    `;
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.classList.remove('show');
      setTimeout(() => notification.remove(), 500);
    }, 2000);
  };

  return (
    <section id="download-app" className="download-section">
      <div className="container">
        {/* Section Header */}
        <div className={`download-header reveal-on-scroll ${isVisible ? 'revealed' : ''}`}>
          <div className="download-badge">
            <i className="fas fa-download"></i>
            <span>Download Aplikasi</span>
          </div>
          <h2 className="section-title">
            Download Platform
            <span className="title-accent">Live Streaming</span>
          </h2>
          <p className="section-subtitle">
            Unduh aplikasi live streaming favorit Anda melalui Google Play Store atau APK
            <br />
            Gunakan kode referral <strong className="referral-code">WANMGMT2024</strong> untuk bonus pendaftaran!
          </p>
          <button className="copy-referral-btn" onClick={copyReferralCode}>
            <i className="fas fa-copy"></i>
            Salin Kode Referral
          </button>
        </div>

        {/* Apps Grid */}
        <div className="apps-grid">
          {apps.map((app, index) => (
            <div 
              key={app.id} 
              className={`app-card reveal-on-scroll ${isVisible ? 'revealed' : ''}`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="app-card-inner">
                {/* App Badge */}
                <div className="app-badge" style={{ background: app.color }}>
                  {app.badge}
                </div>
                
                {/* App Icon - Menggunakan gambar PNG */}
                <div className="app-icon-wrapper">
                  <div className="app-icon" style={{ background: `linear-gradient(135deg, ${app.color}, ${app.color}dd)` }}>
                    <img 
                      src={app.iconImage} 
                      alt={`${app.name} icon`}
                      className="app-icon-img"
                    />
                  </div>
                </div>
                
                {/* App Info */}
                <h3 className="app-name">{app.name}</h3>
                <p className="app-description">{app.description}</p>
                
                {/* Download Buttons */}
                <div className="download-buttons">
                  <button 
                    className="download-btn playstore"
                    onClick={() => handleDownload(app.playStoreUrl, app.name, 'playstore')}
                  >
                    <i className="fab fa-google-play"></i>
                    <div className="btn-text">
                      <span className="btn-label">Download on the</span>
                      <span className="btn-store">Google Play</span>
                    </div>
                  </button>
                  
                  <button 
                    className="download-btn apk"
                    onClick={() => handleDownload(app.apkUrl, app.name, 'apk')}
                  >
                    <i className="fas fa-download"></i>
                    <div className="btn-text">
                      <span className="btn-label">Download</span>
                      <span className="btn-store">Android APK</span>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* QR Code Section */}
        <div className={`qr-section reveal-on-scroll ${isVisible ? 'revealed' : ''}`}>
          <div className="qr-container">
            <div 
              className={`qr-code-wrapper ${qrHover ? 'hover' : ''}`}
              onMouseEnter={() => setQrHover(true)}
              onMouseLeave={() => setQrHover(false)}
            >
              <div className="qr-code">
                <i className="fas fa-qrcode"></i>
                <div className="qr-overlay">
                  <span>Scan Me!</span>
                </div>
              </div>
              <div className="qr-text">
                <i className="fas fa-mobile-alt"></i>
                <span>Scan QR Code untuk download semua aplikasi</span>
              </div>
            </div>
            
            <div className="qr-info">
              <h4>
                <i className="fas fa-gift"></i>
                Bonus Pendaftaran!
              </h4>
              <p>Daftar melalui link referral kami dan dapatkan:</p>
              <ul>
                <li><i className="fas fa-check-circle"></i> Bonus welcome 50 diamonds</li>
                <li><i className="fas fa-check-circle"></i> Bimbingan eksklusif dari agensi</li>
                <li><i className="fas fa-check-circle"></i> Tips & trik menjadi host sukses</li>
                <li><i className="fas fa-check-circle"></i> Kesempatan join event berhadiah</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className={`download-cta reveal-on-scroll ${isVisible ? 'revealed' : ''}`}>
          <div className="cta-content">
            <i className="fas fa-headset"></i>
            <h3>Butuh Bantuan?</h3>
            <p>Jika mengalami kendala saat download, hubungi customer support kami</p>
            <a 
              href="https://wa.me/6285930139333" 
              className="cta-support-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-whatsapp"></i>
              Hubungi Support
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DownloadApp;
